<template>
  <div class="pwc-app-drawlots">
    <v-stage
      ref="stage"
      :config="configKonva"
      class="stage stage-1"
      :style="{ width: `${supportWidth}px` }"
    >
      <layer-bg />
      <layer-main ref="layer-main" @draw="handleDraw" />
      <layer-text ref="layer-text" />
      <layer-pic
        ref="layer-pic"
        :picture="selectedPic"
        @generate="handleGeneratePoster"
      />
      <layer-poster
        ref="layer-poster"
        :picture="selectedPic"
        :text="currentText"
      />
    </v-stage>
    <div
      v-if="useAction"
      class="pwc-file-select"
      :style="actionStyle"
      @click="handleWechatSelectPic"
    >
      <label v-if="!isWechat || !isMobile" for="file-select" />
      <input
        v-if="!isWechat || !isMobile"
        id="file-select"
        type="file"
        accept="image/x-png,image/jpeg,image/png"
        @change="handleSelectedPic"
      >
    </div>
    <van-dialog
      :value="showPosterDialog"
      class="pwc-dialog-poster"
      :style="posterPreviewStyle"
      :show-confirm-button="false"
    >
      <div class="pwc-poster-preview">
        <van-icon name="close" @click="handleDialogConfirm" />
        <img :src="posterUrl">
        <div class="tips">长按上方图片保存</div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showWechatPublicAccountQr"
      class="pwc-dialog-wechat"
      :title="isWechat ? '长按二维码 关注公众号' : '保存二维码 微信关注公众号'"
      :show-confirm-button="!isWechat"
      confirm-button-text="我知道了"
    >
      <img class="public-qr" :src="ypPublicQr">
    </van-dialog>
    <dialog-cropper
      v-if="showCropper"
      :src="cropperSrc"
      :ratio="597 / 384"
      @crop="handleCrop"
    />
  </div>
</template>

<script>
import Detect from '@/util/detect'
import { Dialog } from 'vant'
import { help } from './help'
import LayerBg from './layer-bg'
import LayerMain from './layer-main'
import LayerText from './layer-text'
import LayerPic from './layer-picture'
import LayerPoster from './layer-poster'
import ypPublicQr from '@/assets/yp-public-qrcode.png'
import { isWechat, isIos } from '@/util/detect'
import initWechat from '@/share'
const isMobile = Detect(window.navigator.userAgent).mobile()
import { wechat, forceCheckAuth } from '@/mixin/index'
import DialogCropper from './dialog-cropper'

export default {
  components: {
    LayerBg,
    LayerMain,
    LayerText,
    LayerPic,
    LayerPoster,
    DialogCropper
  },
  mixins: [help, wechat, forceCheckAuth],
  data() {
    return {
      isMobile,
      isWechat,
      isIos,
      configKonva: {},
      actionStyle: {},
      posterPreviewStyle: {
        width: `${this.getMaxPosterPreviewWidth()}px`
      },
      selectedPic: null,
      currentText: null,
      useAction: false,
      showPosterDialog: false,
      posterUrl: '',
      supportWidth: isMobile ? window.innerWidth : this.getMaxSupportWidth(),
      showWechatPublicAccountQr: false,
      showCropper: false,
      cropperSrc: '',
      ypPublicQr
    }
  },
  async created() {
    this.init()
  },
  async mounted() {
    this.initDomActionStyle()
    await this.checkWechatAuth()
    // ios wechat toolbar will have history after wechat oauth
    window.addEventListener('popstate', () => {
      location.reload()
    })
  },
  methods: {
    init() {
      if (this.isWechat) {
        initWechat({
          description: 'Intership Challenge Season IV'
        }).then(() => {
          // eslint-disable-next-line no-undef
          wx.hideMenuItems({
            menuList: ['menuItem:copyUrl']
          })
        })
      }
      const MaxSupportWidth = this.getMaxSupportWidth()
      const width =
        window.innerWidth > MaxSupportWidth
          ? MaxSupportWidth
          : window.innerWidth
      const height = window.innerHeight
      this.configKonva = Object.assign({}, this.configKonva, { width, height })
    },
    initDomActionStyle() {
      const layerPicture = this.$refs['layer-pic']
      this.tryExist(
        async() => {
          const attrs = await layerPicture.getFileBtnPosition()
          return attrs.width
        },
        async() => {
          const attrs = await layerPicture.getFileBtnPosition()
          this.actionStyle = {
            // left: attrs.x + 'px', use transform, to support desktop
            top: attrs.y + 'px',
            width: attrs.width + 'px',
            height: attrs.height + 'px'
          }
        }
      )
    },
    async handleDraw() {
      try {
        const layerText = this.$refs['layer-text']
        const layerMain = this.$refs['layer-main']
        const layerPicture = this.$refs['layer-pic']
        const text = await layerText.getCurrentText()
        this.useAction = true
        this.currentText = text
        await layerMain.hide()
        await layerText.hide()
        await layerPicture.show()
      } catch (error) {
        console.error(error)
      }
    },
    handleSelectedPic(e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = (evt) => {
        if (evt.target.readyState === FileReader.DONE) {
          this.cropperSrc = evt.target.result
          this.showCropper = true
        }
      }
      e.target.value = ''
    },
    async handleWechatSelectPic() {
      if (!this.isWechat || !this.isMobile) {
        return
      }
      try {
        const imgId = await new Promise((resolve, reject) => {
          // eslint-disable-next-line no-undef
          wx.chooseImage({
            count: 1,
            sizeType: ['original', 'compressed'],
            sourceType: ['album', 'camera'],
            success: (res) => {
              resolve(res.localIds[0])
            },
            error: (err) => {
              reject(err)
            }
          })
        })
        const imgData = await new Promise((resolve, reject) => {
          // eslint-disable-next-line no-undef
          wx.getLocalImgData({
            localId: imgId,
            success: (res) => {
              resolve(res.localData)
            },
            error: (err) => {
              reject(err)
            }
          })
        })
        if (this.isIos) {
          this.cropperSrc = imgData
        } else {
          this.cropperSrc =
            'data:image/jpeg;base64,' + imgData.replace(/\n/g, '')
        }
        this.showCropper = true
      } catch (error) {
        console.error(error)
      }
    },
    async handleGeneratePoster() {
      if (!this.selectedPic) {
        return Dialog.alert({
          title: '请选择一张图片',
          message: '请选择一张图片作为海报内容'
        })
      }
      const layerPicture = this.$refs['layer-pic']
      const layerPoster = this.$refs['layer-poster']
      layerPicture.hide()
      layerPoster.show()
      this.$nextTick(() => {
        this.posterUrl = this.$refs.stage.getNode().toDataURL({
          pixelRatio: 6,
          x: 0,
          y: 0,
          width: this.transformWH(750),
          height: this.transformWH(1334)
        })
        this.showPosterDialog = true
      })
    },
    handleDialogConfirm() {
      const layerPicture = this.$refs['layer-pic']
      const layerPoster = this.$refs['layer-poster']
      layerPicture.show()
      layerPoster.hide()
      this.$nextTick(() => {
        this.showPosterDialog = false
      })
    },
    handleCrop(img) {
      this.selectedPic = img
      this.showCropper = false
    },
    getMaxPosterPreviewWidth() {
      // 86 = title + height
      // 320 = vant default content width for dialog
      const width =
        (window.innerHeight - 86) *
        0.8 *
        (window.innerWidth / window.innerHeight)
      return width > 320 ? 320 : width
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-app-drawlots {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("../../assets/self-diagnosis-bg.jpg");
  background-size: cover;
  .stage {
    position: relative;
    display: flex;
    justify-content: center;
    margin: auto;
    background-color: rgb(252, 170, 16);
  }
  .pwc-file-select {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    input,
    label {
      display: block;
      cursor: pointer;
    }
    input {
      width: 0;
      height: 0;
      display: none;
    }
    label {
      width: 100%;
      height: 100%;
    }
  }
  .pwc-poster-preview {
    user-select: none;
    span {
      user-select: none;
      color: #fff;
      display: block;
      text-align: center;
      line-height: 36px;
      font-weight: bold;
      background-color: #d04a02;
      height: 36px;
    }
    img {
      user-select: none;
      user-select: none;
      display: block;
      width: 100%;
    }
    .tips {
      color: #fff;
      font-weight: bold;
      text-align: center;
      line-height: 38px;
    }
  }
  .pwc-dialog-wechat {
    user-select: none;
    img {
      width: 160px;
      height: 160px;
      display: block;
      margin: auto;
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }
}
</style>

<style lang="scss">
.pwc-app-drawlots {
  .pwc-dialog-poster.van-dialog {
    margin-top: 12px;
    user-select: none;
    background-color: #d04a02;
  }
}
.pwc-app-drawlots {
  .van-dialog__header,
  .van-button__content,
  .van-dialog__content {
    user-select: none;
  }
}

.pwc-dialog-poster {
  .van-icon.van-icon-close {
    position: absolute;
    font-size: 32px;
    color: #fff;
    right: 2px;
    top: 2px;
  }
}
</style>
